





















































































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';
import ICheck from '@/components/icons/ICheck.vue'

const dialog = namespace('dialog')
const forms = namespace('forms')
const newshards = namespace('newshards')
const locale = namespace('locale')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    'i-check': ICheck,
  },
  name: "ExportOneForm"
})
export default class ExportOneForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @forms.Getter('options') protected options:any
  @newshards.Action('exportOneShardsCompany') protected exportOneShardsCompany: any
  @locale.Getter('getLocale') protected getLocale:any

  loading:boolean = false
  checkedEmail:boolean = true
  isError:boolean = false
  email:string = ''
  workspace: string = ''

  @Watch('fullDialogShow')
  setExport() {
    this.loading = false
    this.checkedEmail = true
    this.isError = false
    this.email = ''
  }

  mounted() {
    this.workspace = this.$route.params.code
  }

  async sendToMail() {
    this.loading = true
    this.checkEmail()
    if(this.checkedEmail) {
      let response = await this.exportOneShardsCompany({
        params: {
          companyCode: this.$route.params.code,
          shardId: this.options.id,
        },
        body: {
          email: this.email,
        },
        message: this.$t('newShardList.export.message.first') + this.email + '. ' + this.$t('newShardList.export.message.second')
      })  
      if(response) {
        this.isError = false
        this.SetFullDialogShow(false)
      } else {
        this.isError = true
        this.loading = false
      }
    }
  }

  checkEmail() {
    if(this.email !== ''){
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(re.test(String(this.email).toLowerCase())){
        this.checkedEmail = true
      }else {
        this.checkedEmail = false
        this.loading = false
      }
    }else {
      this.checkedEmail = false
      this.loading = false
    }
  }

}
